import _typeof from "@babel/runtime/helpers/esm/typeof";
/**
 * @private
 * @typedef RemoveEmptyValuesOptions
 * @type {object}
 * @name options
 * @property {boolean} options.removeEmptyStrings - option to remove empty strings
 */

/**
 * removeEmptyValues
 *
 * @memberof ux-tread-dotcom-utils
 * @description Removes any key with null or conditionally empty strings from given object
 * This is necessary for certain api calls where nested objects do not expect empty strings but
 * parts of client data might have empty strings
 * @param {object} obj - A javascript object
 * @param {RemoveEmptyValuesOptions} options - options which include toggling functionality to remove empty strings
 * @returns {object} A modified object removed of any empty values, optionally
 */
export default function removeEmptyValues(obj) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    removeEmptyStrings: false
  };
  var removeEmptyStrings = options.removeEmptyStrings;
  Object.keys(obj).forEach(function (key) {
    var value = obj[key];
    if (value && _typeof(value) === 'object') {
      removeEmptyValues(value, options);
    } else if (value == null || removeEmptyStrings && value === '') {
      delete obj[key];
    }
  });
  return obj;
}